/**
 * @(#)2019/6/10.
 * @author 飞光
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import Moment from "moment";
import Basics from "../Basics";
import ReactDOM from "react-dom";
import React, { cloneElement } from "react";
import Utils, { toArray, get, yxTextIimeProps } from "../../../utils";
import { YxComponent, Connection } from "../../YxComponent";

//默认props
let defaul = () => {
  return {
    format: "YYYY-MM-DD HH:mm:ss", //时间格式 dd/hh/mm/ss 默认为ss
    isTimeZone: false, //时区功能，如果开启该功能,则将时间转为当前时区时间输出，输入的最好是UTC时间格式，且必须非时间戳，这样才能得到正确结果
    children: "", //子节点
  };
};
/*
 * Time，展示时间的组件
 * @param children {String} 子节点，需要展示的内容
 * @param isTimeZone {bool} 时区功能，如果开启该功能,则将时间转为当前时区时间输出，输入的最好是UTC时间格式，且必须非时间戳，这样才能得到正确结果
 * */
@Connection(defaul)
export default class Time extends YxComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }
  //处理时间
  handle(str) {
    let props = this.props;
    try {
      let timeObj = Utils.timeZone(str, props.format, props.isTimeZone);
      //如果是时间戳转时间
      str = timeObj.currentZoneTime;
      return str;
    } catch (e) {
      console.log(e);
    }
  }

  isMoment = (value) => {
    const values = toArray(value);
    return values.some((v) => v.__proto__.format instanceof Function);
  };

  render() {
    let tmpProps = { ...this.props };
    const value = get(tmpProps, ["children", "value"], "");
    const format = get(tmpProps, "format", "YYYY-MM-DD HH:mm:ss");
    let childrenType = typeof tmpProps.children;
    if (childrenType == "string" || childrenType == "number") {
      tmpProps.children = this.handle(tmpProps.children);
    } else if (this.isMoment(value)) {
      tmpProps.children = toArray(value)
        .map((m) => m.format(format))
        .join(" - ");
    }
    let html = Basics.html(yxTextIimeProps(tmpProps));
    return html;
  }
}



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxText/Time/Time.js